import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/header'
import { ExpandMore } from "@material-ui/icons";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@material-ui/core";
import ReactGA from 'react-ga'
import InstituteTabs from "../components/institutiontabs";
import ScrollAnimation from 'react-animate-on-scroll';
import '../css/programs-page.css'
import Footer from '../components/footer';
import cardImg from '../images/programs/degree.svg'
import cardImg1 from '../images/programs/start online.svg'
import cardImg2 from '../images/programs/get your visa.svg'
import cardImg3 from '../images/programs/completed overseas.svg'
import unismarterImage1 from '../images/programs/simply the best.svg'
import unismarterImage2 from '../images/programs/save big.svg'
import unismarterImage3 from '../images/programs/maximum value.svg'
import unismarterImage4 from '../images/programs/save time and trouble.svg'
import bussinessImag from '../images/programs/Business.png'
import commerseImag from '../images/programs/Commerce.png'
import computerImage from '../images/programs/ComputerScience.png'
import sampleOfferImage from '../images/programs/p1.png'
import {Link, graphql} from 'gatsby'
import "../css/sharan-style.css";
import "../css/animate.min.css";
import "../css/style.css";
import UniversityCardView from '../components/UniversityCardView';
import PartnerUniversities from '../components/partner-universities';
import {  Tabs,  TabPanel } from 'react-tabs';
import { BsFillCircleFill } from 'react-icons/bs';
import AmericanDreamRequirements from '../components/AmericanDreamRequirements';
import FaqSection from '../components/FAQSection';
import GoaFaqSection from '../components/GoaFaqSection';

const Goa = (wpUniInfo) => {
    // const {width} =useWindowDimension()

    const uniArr = wpUniInfo.data.allWordpressWpUniversities.nodes

    const [value, setValue] = React.useState(0);
    const [cardData, setCardData] = useState([
        {
            image: cardImg, title: "Choose Your Degree", text: "Get admission to University of Wollongong - a top 200 university, in one of 5 degree outcomes across business or IT streams. "
        },
        {
            image: cardImg1, title: "Start Online", text: "Complete the first year of your degree online in just 3.5 months (2 modules in 7 weeks)  without any delays thanks to multiple intakes (intake every 2 months)."
        },
        {
            image: cardImg2, title: "Get Your Visa", text: "Complete your visa process while studying and be ready to go to Australia by the end of the GOA program."
        },
        {
            image: cardImg3, title: "Complete Overseas", text: "Progress to the overseas campus to complete the remainder of your degree and apply for post study work rights."
        }
    ])
    const [coursesGridData, setCoursesGridData] = useState([
        {
            image: bussinessImag, text: "Business & Management", gridR: "1/2", gridC: "1/2",gridRM:'1/2',gridCM:'1/4'
        },
        {
            image: commerseImag, text: "Commerce & Finance", gridR: "1/2", gridC: "2/3",gridRM:'2/3',gridCM:'1/4'
        },
        {
            image: computerImage, text: "Computer Science & Information Technology", gridR: "1/2", gridC: "3/4",gridRM:'3/4',gridCM:'1/4'
        },
        
    ])
    const [collapse, setCollapse] = useState([
        {
            title: "Marketing Principles",
            body:`The subject examines basic marketing concepts to build up a sound understanding of marketing principles. The material assists those who want to be specialist marketers and those interested in undertaking other business or professional studies. What you learn in this subject will be of value to you for the rest of your lives as consumers and as members of the business community.

            The module covers topics like creation of customer value, marketing strategies, marketing analytics, product & pricing, digital marketing and a lot more.
            `
        },
        {
            title: "Accounting Fundamentals In Society",
            body:`Accounting Fundamentals in Society introduces the role of accounting information in society including its social and ethical aspects relating to both the individual and the organisation. The subject introduces basic accounting language, concepts and techniques to identify, classify, process, record and present accounting and financial information. The subject also considers accounting information that can be used for making decisions about past and future economic events in a variety of business and social settings.

            The course includes concepts of accounting and financial statements for decision making, recording transactions and preparing financial statements , completing accounting cycles and accounting for retailers and merchandisers, analysis of financial statements and more.
            
            On completion of the course, students will be able to analyze different stakeholders involved in the development of computer based information systems, identifying different system techniques, analysis of computer based information systems and more.
            `   
          },
        {
            title: "Introduction to Management",
            body:`This subject will introduce students to key management theories and concepts including organisational culture, social responsibility, ethics, managing groups, motivating employees, planning, managing human resources and employment relations, strategic management, decision-making, managing operations, leadership and foundations of management control.

            The course is designed to provide an opportunity for students to acquire understanding through a series of lectures supported by student participation in simulation activities. The subject is presented from the point of view of managers, but students will learn how the different interests between organisational stakeholders affect various management processes.
            
            The module will create foundational knowledge on topics of management, manager’s role, management of groups, teams and communication, corporate office environment, management strategy and decision making.
            `      
        },
        {
            title: "Economic Essentials for Business",
            body:`The course will introduce students to economics and relate it to the world
            of business and economic management to establish a sound foundation to understand economic events and principles in Australia and any market economy. The knowledge and skills developed in economics is the basis of managing resources and understanding the world of business and government.
            
            The module will explore topics like introduction to economics, micro economics and macro economics
            `     
          },
       

    ])

    const [collapse2,setCollapse2]=useState([
        {
            title:"Introduction to Web Technology",
            body:`This subject will introduce students to the foundational technologies that support the World Wide Web and enable its commercial applications. The topics for this subject include HTML5, CSS3, Web Forms, XML and its definition languages, XSLT, JavaScript, AJAX and JSON. Within the scope of these topics, students will design content that includes dynamic and event-driven components along with CSS styling. This subject will also explore the options that are available for integrating server-side resources (e.g. images, files and code) into client-side applications.

            On completion of this course, students will be able to analyze and describe main web technologies, configuration of web server emulator and alot more.
            `
        },
       {
           title:"Networks and Communications",
           body:`The subject will introduce students to fundamentals of data communications and computer networks. Topics covered include: different types of data and the history of data communications; signals, modulation and multiplexing; switching technologies and routing; network architectures: LANS, WANs and the Internet; Internet services, multimedia services, broadband services and internet protocols; emerging technologies: optical and wireless networks. The subject explains computer networking models that interconnect diverse communication systems, including the ISO reference model and the TCP/IP Suite.`
       },
       {
           title:"Programming Fundamentals",
           body:`The broad aim of this subject is to develop in students an understanding of the fundamental principles of programming. The subject focuses on the object-oriented view of problem analysis and solving. It enables students to develop skills in the design and implementation of well-structured programs in a range of domains.`
       },
       {
           title:"System Analysis",
           body:`This subject provides an introduction to different techniques and technologies for
           understanding and specifying what a computer based information system should
           accomplish. It examines the complementary roles of systems analysts, clients and users in a system development life cycle. Students will learn different fact-finding techniques to elicit system requirements and how to develop business models, data and process models, and object models representing a system. Students will also make use of a Computer Aided Software Engineering (CASE) tool to build those models that capture the specifications of a system.
           `
       },
    ])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
        <div className="program-page" style={{fontFamily: "caros"}}>
            <Helmet>
                <title>
                    GOA | The WorldGrad
                </title>
                <meta
                    name="description"
                    content="Get answers to all your study abroad questions on topics like  like, program options to choose from, pros and cons of different countries, student visa application process, how to finance your overseas education, most value for money universities, entry requirement to get into a good university and much more in The WorldGrad study resources section." />
                <meta
                    name="keywords"
                    content="study abroad, study overseas, educations courses, student visas, universities" />
                <link rel="icon" href="https://res.cloudinary.com/worldgrad/image/upload/v1612961357/worldgrad/twg_favicon_ymgrbw.png" />

            </Helmet>
            <Header />

            <div className="container-fluid american-dream-banner-section-goa mt-md-3 d-flex justify-content-center align-items-center">
                <div className="row">
                    {/* <div> */}
                        <div className="col-12 ">
                            <p className='text-muted american-dream-breadcrumb'>
                                Programs - <p className='american-dream-breadcrumb-alt'> Global Online Accelerator Program </p> 
                            </p>
                        </div>
                        <div className="col-12">
                            <h1 className='text-center' style={{color: "#fff"}}>
                                Global Online Accelerator Program (GOAP)
                            </h1>
                        </div>
                        <div className="col-12">
                            <h5 className='text-center pt-md-4 american-dream-banner-subtext'>
                            Kickstart your undergraduate degree at top-ranked universities in Australia and the world
                            </h5>
                        </div>
                    {/* </div> */}
                </div>
            </div>

            <div className="section py-5" style={{backgroundColor: "#fff"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h4 className='american-dream-section-one-heading' style={{textTransform: "uppercase"}}>
                                Start online with the GOA Program and progress to UOW College  
                            </h4>
                        </div>
                        <div className="col-12">
                            <h6 className='american-dream-section-one-subtext'>
                                The Global Online Accelerator Program allows students to do their first semester, i.e., 4 modules of their UG degree online at home before progressing to the UOW campus to continue their education, i.e., second semester onwards.
                            </h6>
                        </div>
                    </div>
                </div>
            </div>

            <section style={{backgroundColor: "#f8f8fa"}}>
                <div className="container py-5">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h3>
                                Our Program Partner
                            </h3>
                            <h6 className='american-dream-subtext'>
                                Students will receive a transcript from our program partner, UOW College/ University Of Wollongong at the end of the GOA Program.
                        </h6>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-around px-md-5">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/16.png" alt=""
                            class="img-fluid mb-3 d-flex mx-auto shadow p-1"
                            style={{ borderRadius: "15px", width: "250px" }}
                        />
                    </div>
                </div>
            </section>

            <section style={{backgroundColor: "#fff"}}>
                <div className="container pt-5 pb-5 pb-md-0">
                    <div className="row">
                        <div className="col-12 text-center mb-4">
                            <h3> The WorldGrad Journey </h3>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-md-4">
                            <div className="col-12">
                                <a href='/global-online-accelerator-program'>
                                    <h5 className='worldgrad-journey-heading' style={{ color: "#FCB017"}}>
                                        Year 1 (Term 1) - Global Online Accelerator Program
                                    </h5>
                                </a>
                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'>
                                    Program Provider - The WorldGrad
                                </h6>
                                <img className='react-icon-arrow-desktop-alt' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                                <h6 className='worldgrad-journey-content'>
                                    Study Mode - Online
                                </h6>
                                <img className='react-icon-arrow-phone' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="col-12">
                                {/* <a href="/americandream"> */}
                                    <h5 className='worldgrad-journey-heading'>
                                        Year 1 (Term 2) - Diploma 
                                    </h5>
                                {/* </a> */}
                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'>
                                    Program Provider - UOW College
                                </h6>
                                <img className='react-icon-arrow-desktop-alt' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                                <h6 className='worldgrad-journey-content'>
                                    Study Mode - On Campus
                                </h6>
                                <img className='react-icon-arrow-phone' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="col-12">
                                <h5 className='worldgrad-journey-heading'> Year 2,3  - Bachelor Degree </h5>
                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'> Course Provider - University Of Wollongong </h6>
                                <h6 className='worldgrad-journey-content'> Study Mode - On Campus </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="american-dream-card-section py-5">
                <div className="container">
                    <div className="row mb-3">
                        <div className="col-12 text-center">
                            <h3 style={{lineHeight: "40px"}}>Why Is the GOA Program The Right Choice For You</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage1} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Simply the best </h5>
                                            <p classname="american-dream-card-text">
                                                The GOAP gets you fast-track entry into a top 10 university in Australia (#193 in QS World Rankings). UOW is also among Australia’s Top 5 Universities for graduate employer satisfaction giving your employability a major boost 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage2} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Save Big </h5>
                                            <p classname="american-dream-card-text">
                                                Save on first year tuition fees and living expenses while also getting access to exclusive scholarships
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage3} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Maximum Value </h5>
                                            <p classname="american-dream-card-text">
                                                Wollonong is the ideal student city with plenty of part-time job opportunities, cheap accommodation, good connectivity with major cities (Sydney is only 45 min away) and post study work rights of 3 years
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage4} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Save Time And Trouble </h5>
                                            <p classname="american-dream-card-text">
                                                No IELTS or Visa required to start the program. Start right away while you prepare to move overseas
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='container-fluid american-dream-top-courses py-5'>
                <div className="row mb-2 mb-md-4">
                    <div className="col-12">
                        <h3 className='text-center'> Top Courses Through GOA Program </h3>
                    </div>
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}>Bachelor Of Computer Science</h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            UOW College/ University Of Wollongong
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 3 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/university-of-wollongong/ug/bachelor-of-computer-science/"
                            // href={course.course_link}
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
                <div className="row mb-2 mb-md-4">
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}>Bachelor Of Business
                        </h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            UOW College/ University Of Wollongong
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 3 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/university-of-wollongong/ug/bachelor-of-business/"
                            // href={course.course_link}
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
                <div className="row mb-2 mb-md-0">
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}> Bachelor Of Commerce</h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            UOW College/ University Of Wollongong
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 3 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/university-of-wollongong/ug/bachelor-of-commerce/"
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
            </div>

            <div className="collapse-section py-5">
                <div className="collapse-section-text-area">
                    <span className="collapse-section-text-area-title">What will you study?</span>
                    <span className="collapse-section-text-area-text">Based on your degree choice you will study the following modules over the course of the GOA program before progressing overseas to UOW College</span>
                </div>
                <div className="placerholder-accordion">

                    <Accordion className="customize-accord" defaultExpanded={false}>
                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title" >
                        Business/Commerce
                            {/* Computer Science/Information Technology */}
                        </AccordionSummary>

                        <AccordionDetails className="customize-accord-body">
                            {
                                collapse.map((e, i) => (
                                    <Accordion defaultExpanded={true} className="customise-accord-color customize-accord">
                                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title-title">
                                            {e.title}
                                        </AccordionSummary>

                                        <AccordionDetails className="customize-accord-body-body">
                                            {e.body}
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            }

                        </AccordionDetails>
                    </Accordion>

                    <Accordion className="customize-accord" defaultExpanded={false}>
                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title" >
                        Computer Science/Information Technology
                        </AccordionSummary>

                        <AccordionDetails className="customize-accord-body">
                            {
                                collapse2.map((e, i) => (
                                    <Accordion key={i} defaultExpanded={true} className="customise-accord-color customize-accord">
                                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title-title">
                                            {e.title}
                                        </AccordionSummary>

                                        <AccordionDetails className="customize-accord-body-body">
                                            {e.body}
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            }

                        </AccordionDetails>
                    </Accordion>

                </div>
            </div>

            <AmericanDreamRequirements 
                QualificationInfo={["All India School Certificate (CBSE): Successful completion of AISSCE with an overall GPA starting from 55% or above", "India Higher Secondary School Certificate (State Boards): Average starting from 55% or above"]}
                EnglishRequirements={["IELTS score starting from 6.0 (or equivalent)"]}
                FeesAndScholarship={["INR 3,48,000 + GST (INR 87,000 + GST per module)", "University Fees starting from AUD 33,849 per annum*", "Scholarships up to AUD 20,000 per annum*"]}
                imgFile="https://media.publit.io/file/TheWorldgrad/9Programs/GlobalOnlineAcceleratorProgram/IMG-20220107-WA0000.jpg"
                imgHeading="Sample Transcript"
            />

            <section className="py-5" style={{backgroundColor: "#f8f8fa"}}> 
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="text-center"> FAQs </h3>
                        </div>
                    </div>
                </div>
                {/* <FaqSection /> */}
                <GoaFaqSection />
            </section>
            <Footer />
        </div>
        </>
    )
}

export default Goa 

export const WorldGradUniversities = graphql`
    {
        allWordpressWpUniversities(filter: {acf: {country: {eq: "Australia"}}}) {
        nodes {
            id
            slug
            title
            acf {
            banner_image {
                source_url
            }
            }
        }
        }
    }
`


